<template>
  <!--房产新增  -->
  <div class="houseAdd">
    <el-card class="box-card">
      <div style="margin-top: 15px">
        <!-- :rules="rules" -->
        <el-form
          label-width="120px"
          size="small"
          :inline="true"
          :model="formData"
          ref="ruleForm"
        >
        <el-row>
           <el-col>
              <el-form-item label="楼盘名字" prop="name">
                <el-input
                  placeholder="请输入内容"
                  v-model="formData.name"
                   class="ipt"
                ></el-input>
              </el-form-item>
            </el-col>
        </el-row>
        <el-row>
          <el-col>
              <el-form-item label="开发商" prop="kaifashang">
                <el-input
                  placeholder="请输入内容"
                  v-model="formData.kaifashang"
                  class="ipt"
                ></el-input>
              </el-form-item>
            </el-col>
        </el-row>
        <el-row>
           <el-col :span="8">
              <el-form-item label="销售阶段" prop="jieduanId">
                <el-select v-model="formData.jieduanId" placeholder="请选择">
                  <el-option
                    v-for="item in xiaoData"
                    :key="item.enumeration"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="销售状态" prop="xiaoshouId">
                <el-select v-model="formData.xiaoshouId" placeholder="请选择">
                  <el-option
                    v-for="item in xiaotai"
                    :key="item.value"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
             <el-col :span="8">
              <el-form-item label="产权年限" prop="chanquanId">
                <el-select v-model="formData.chanquanId" placeholder="请选择">
                  <el-option
                    v-for="item in chanData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="项目简介" prop="jianjie">
            <el-input
                  placeholder="请输入内容"
                  v-model="formData.jianjie"
                  type="textarea"
                ></el-input>
              </el-form-item>
            </el-col>
        </el-row>

            <el-row>
               <el-col :span="24">
              <el-form-item label="楼盘地址" prop="address">
                <el-input
                  placeholder="请输入内容"
                  v-model="formData.address"
                  type="textarea"
                ></el-input>
              </el-form-item>
            </el-col>
            </el-row>

            <el-row>
               <el-col :span="24">
              <el-form-item label="售楼地址" prop="shoulou">
                <el-input
                  placeholder="请输入内容"
                  v-model="formData.shoulou"
                   type="textarea"
                ></el-input>
              </el-form-item>
            </el-col>
            </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="车位数量+车位描述" prop="chewei">
                <el-input
                  placeholder="请输入内容"
                  v-model="formData.chewei"
                  type="textarea"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- <el-col :span="8">
              <el-form-item label="物业描述" prop="miaoshu">
                <el-input placeholder="请输入内容" v-model="formData.miaoshu"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="8">
              <el-form-item label="物业费（元/月）" prop="wuyefei">
                <el-input
                  placeholder="请输入内容"
                  v-model="formData.wuyefei"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="物业公司" prop="wuyegongsi">
                <el-input
                  placeholder="请输入内容"
                  v-model="formData.wuyegongsi"
                  class="setIpt"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
             <el-col :span="8">
              <el-form-item label="均价" prop="junjia" class="flexForm">
                <el-input
                  placeholder="请输入内容"
                  v-model="formData.junjia"
                ></el-input>
                （元）
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="报价日期" prop="baojiaDate">
                <el-date-picker v-model="formData.baojiaDate" type="datetime" placeholder="选择日期"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="开盘时间" prop="kaipan">
                <el-date-picker
                  v-model="formData.kaipan"
                  type="datetime"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
             <el-col :span="8">
              <el-form-item label="售楼处电话" prop="phone">
                <el-input
                  placeholder="请输入内容"
                  v-model="formData.phone"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="区县" prop="quxian">
                <el-select placeholder="请选择" v-model="formData.quxian">
                  <el-option
                    v-for="item in quData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
             <el-col :span="8">
              <el-form-item label="环线 " prop="huanxianId">
                <el-select placeholder="请选择" v-model="formData.huanxianId">
                  <el-option
                    v-for="item in huanData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="别名" prop="bieming">
                <el-input placeholder="请输入内容" v-model="formData.bieming"></el-input>
              </el-form-item>
            </el-col> -->

          </el-row>
          <el-row>
            <!-- <el-col :span="8">
              <el-form-item label="商圈" prop="shangquan">
                <el-input placeholder="请输入内容" v-model="formData.shangquan"></el-input>
              </el-form-item>
            </el-col> -->



          </el-row>
          <el-row>

            <!-- <el-col :span="8">
              <el-form-item label="临时售楼地址" prop="linshi">
                <el-input placeholder="请输入内容" v-model="formData.linshi"></el-input>
              </el-form-item>
            </el-col> -->

          </el-row>
          <el-row>


          </el-row>

          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="最高价" prop="zuigao">
                <el-input placeholder="请输入内容" v-model="formData.zuigao"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="最低价" prop="zuidi">
                <el-input placeholder="请输入内容" v-model="formData.zuidi"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="参考均价" prop="cankao">
                <el-input placeholder="请输入内容" v-model="formData.cankao"></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="价格描述" prop="jiagemiao">
                <el-input placeholder="请输入内容" v-model="formData.jiagemiao"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="当前折扣" prop="zhekou">
                <el-input placeholder="请输入内容" v-model="formData.zhekou"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="按揭银行 " prop="bankId">
                <el-select v-model="formData.bankId" placeholder="请选择">
                  <el-option
                    v-for="item in jieData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row>

            <!-- <el-col :span="8">
              <el-form-item label="入住时间" prop="ruzhu">
                <el-date-picker v-model="formData.ruzhu" type="datetime" placeholder="选择日期"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="开工时间" prop="kaigong">
                <el-date-picker v-model="formData.kaigong" type="datetime" placeholder="选择日期"></el-date-picker>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <!-- <el-col :span="8">
              <el-form-item label="竣工时间" prop="jungong">
                <el-date-picker v-model="formData.jungong" type="datetime" placeholder="选择日期"></el-date-picker>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="8">
              <el-form-item label="报价日期" prop="baojiaDate">
                <el-date-picker v-model="formData.baojiaDate" type="datetime" placeholder="选择日期"></el-date-picker>
              </el-form-item>
            </el-col> -->

          </el-row>

          <el-row>
            <el-col :span="8">
              <!-- <el-form-item label="建筑类别（其他）" prop="jianzhulouOther">
                <el-input placeholder="请输入内容" v-model="formData.jianzhulouOther"></el-input>
              </el-form-item>-->
            </el-col>


            <!-- <el-col :span="8">
              <el-form-item label="别墅建筑类别" prop="bieshuTypeId">
                <el-select v-model="formData.bieshuTypeId" placeholder="请选择">
                  <el-option
                    v-for="item in bieData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="8">
              <el-form-item label="别墅风格" prop="bieshuFenggeId">
                <el-select v-model="formData.bieshuFenggeId" placeholder="请选择">
                  <el-option
                    v-for="item in shuData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
          </el-row>


          <el-row>
            <!-- <el-col :span="8">
              <el-form-item label="物业顾问公司" prop="guwengongsi">
                <el-input placeholder="请输入内容" v-model="formData.guwengongsi"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="产权描述" prop="chanquanMiaoshu">
                <el-input placeholder="请输入内容" v-model="formData.chanquanMiaoshu"></el-input>
              </el-form-item>
            </el-col> -->

          </el-row>

          <el-row>
            <el-col :span="8">
              <el-form-item label="容积率" prop="rongji" class="flexForm">
                <el-input
                  placeholder="请输入内容"
                  v-model="formData.rongji"
                ></el-input>
                （%）
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="绿化率" prop="lvhua" class="flexForm">
                <el-input
                  placeholder="请输入内容"
                  v-model="formData.lvhua"
                ></el-input>
                （%）
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="楼栋数" prop="loudong" class="flexForm">
                <el-input
                  placeholder="请输入内容"
                  v-model="formData.loudong"
                ></el-input>
                （栋）
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>

            <el-col :span="8">
              <el-form-item label="总户数" prop="zonghu" class="flexForm">
                <el-input
                  placeholder="请输入内容"
                  v-model="formData.zonghu"
                ></el-input>
                （户）
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="住宅类别" prop="zhuzhaileiId">
                <el-select v-model="formData.zhuzhaileiId" placeholder="请选择">
                  <el-option
                    v-for="item in zhuData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="建筑类别（楼样式）" prop="jianzhulouId">
                <el-select v-model="formData.jianzhulouId" placeholder="请选择">
                  <el-option
                    v-for="item in jianData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="已开发期数" prop="kaifa">
                <el-input placeholder="请输入内容" v-model="formData.kaifa"></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
             <el-col :span="8">
              <el-form-item label="建筑类别（层样式）" prop="jianzhucengId">
                <el-select
                  v-model="formData.jianzhucengId"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in leiData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="建筑面积" prop="jianzhuMianji" class="flexForm">
                <el-input
                  placeholder="请输入内容"
                  v-model="formData.jianzhuMianji"
                ></el-input>
                （㎡）
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="占地面积" prop="zhandiMianji" class="flexForm">
                <el-input
                  placeholder="请输入内容"
                  v-model="formData.zhandiMianji"
                ></el-input>
                （㎡）
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="当前期数" prop="dangqian">
                <el-input placeholder="请输入内容" v-model="formData.dangqian"></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="楼层状况" prop="zhuangkuang">
                <el-input
                  placeholder="请输入内容"
                  v-model="formData.zhuangkuang"
                  type="textarea"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- <el-col :span="8">
              <el-form-item label="车位出售价格" prop="cheweiChushou">
                <el-input placeholder="请输入内容" v-model="formData.cheweiChushou"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="车位出租价格" prop="cheweiChuzu">
                <el-input placeholder="请输入内容" v-model="formData.cheweiChuzu"></el-input>
              </el-form-item>
            </el-col> -->

            <el-col :span="8">
              <el-form-item label="装修状况（字段表）" prop="zhuangxiuId">
                <el-select placeholder="请选择" v-model="formData.zhuangxiuId">
                  <el-option
                    v-for="item in xiuData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="坐标-经度" prop="longitude">
                <el-input
                  placeholder="请输入内容"
                  v-model="formData.longitude"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="坐标-纬度" prop="latitude">
                <el-input
                  placeholder="请输入别名"
                  v-model="formData.latitude"
                ></el-input>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="8">
              <el-form-item label="供电" prop="gongdian">
                <el-input placeholder="请输入内容" v-model="formData.gongdian"></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>

          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="结构" prop="jiegou">
                <el-input placeholder="请输入内容" v-model="formData.jiegou"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="供气" prop="gongqi">
                <el-input placeholder="请输入内容" v-model="formData.gongqi"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="外墙" prop="waiqiang">
                <el-input placeholder="请输入内容" v-model="formData.waiqiang"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row> -->
          <!-- <el-col :span="8">
              <el-form-item label="采暖" prop="cainuan">
                <el-input placeholder="请输入内容" v-model="formData.cainuan"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="内墙" prop="neiqiang">
                <el-input placeholder="请输入内容" v-model="formData.neiqiang"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="电梯" prop="dianti">
                <el-input placeholder="请输入内容" v-model="formData.dianti"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8">
              <el-form-item label="通讯" prop="tongxun">
                <el-input placeholder="请输入内容" v-model="formData.tongxun"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="电梯服务户数" prop="hushu">
                <el-input placeholder="请输入内容" v-model="formData.hushu"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="门窗" prop="menchuang">
                <el-input placeholder="请输入内容" v-model="formData.menchuang"></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->

          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="卫生间" prop="weishengjian">
                <el-input placeholder="请输入内容" v-model="formData.weishengjian"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="大堂" prop="datang">
                <el-input placeholder="请输入内容" v-model="formData.datang"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="厨房" prop="chufang">
                <el-input placeholder="请输入内容" v-model="formData.chufang"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8">
              <el-form-item label="首层大堂墙面" prop="qiangmian">
                <el-input placeholder="请输入内容" v-model="formData.qiangmian"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="卧室地面" prop="dimian">
                <el-input placeholder="请输入内容" v-model="formData.dimian"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="地面材料" prop="cailiao">
                <el-input placeholder="请输入内容" v-model="formData.cailiao"></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->

          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="电梯间" prop="diantijian">
                <el-input placeholder="请输入内容" v-model="formData.diantijian"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="室内涂料" prop="tuliao">
                <el-input placeholder="请输入内容" v-model="formData.tuliao"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="公共走廊，消防楼" prop="zoulang">
                <el-input placeholder="请输入内容" v-model="formData.zoulang"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8">
              <el-form-item label="门禁" prop="menjin">
                <el-input placeholder="请输入内容" v-model="formData.menjin"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="电梯间墙面" prop="tiQiangmian">
                <el-input placeholder="请输入内容" v-model="formData.tiQiangmian"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="信报箱" prop="xinbaoxiang">
                <el-input placeholder="请输入内容" v-model="formData.xinbaoxiang"></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->

          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="电视系统" prop="dianshi">
                <el-input placeholder="请输入内容" v-model="formData.dianshi"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="中水系统" prop="zhongshui">
                <el-input placeholder="请输入内容" v-model="formData.zhongshui"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="空调系统" prop="kongtiao">
                <el-input placeholder="请输入内容" v-model="formData.kongtiao"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="安防系统" prop="anfang">
                <el-input placeholder="请输入内容" v-model="formData.anfang"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="电子围栏" prop="weilan">
                <el-input placeholder="请输入内容" v-model="formData.weilan"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="交通" prop="jiaotong">
                <el-input placeholder="请输入内容" v-model="formData.jiaotong"></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row>
            <!-- <el-col :span="8">
              <el-form-item label="周边设施" prop="zhoubian">
                <el-input placeholder="请输入内容" v-model="formData.zhoubian"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="小区内部配套" prop="neibu">
                <el-input placeholder="请输入内容" v-model="formData.neibu"></el-input>
              </el-form-item>
            </el-col> -->

          </el-row>

          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="投资商" prop="touzishang">
                <el-input placeholder="请输入内容" v-model="formData.touzishang"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="建筑及园林设计单位" prop="yuanlindanwei">
                <el-input placeholder="请输入内容" v-model="formData.yuanlindanwei"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="承建商" prop="chengjianshang">
                <el-input placeholder="请输入内容" v-model="formData.chengjianshang"></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="代理商" prop="dailishang">
                <el-input placeholder="请输入内容" v-model="formData.dailishang"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="景观设计单位" prop="jingguansheiji">
                <el-input placeholder="请输入内容" v-model="formData.jingguansheiji"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="整合推广单位" prop="tuiguang">
                <el-input placeholder="请输入内容" v-model="formData.tuiguang"></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->

          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="平面媒体广告单位" prop="pingmianmeiti">
                <el-input placeholder="请输入内容" v-model="formData.pingmianmeiti"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="标签" prop="biaoqian">
                <el-input placeholder="请输入内容" v-model="formData.biaoqian"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="评分(1-10)" prop="biaoqian">
              <a-input-number :min="0" :max="10" :step="0.1" @change="onChange" style="width:100px"/>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row>
            <el-form-item label="推荐猜你喜欢" prop="isLike">
              <el-radio-group
                v-model="formData.isLike"
                style="width: 100%; margin-top: 10px"
              >
                <el-radio :label="0" value="0">不推荐</el-radio>
                <el-radio :label="1" value="1">推荐</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="热门房产" prop="isHot">
              <el-radio-group
                v-model="formData.isHot"
                style="width: 100%; margin-top: 10px"
              >
                <el-radio :label="1" value="1">是</el-radio>
                <el-radio :label="0" value="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-row>
          <!-- <el-row>
            <el-form-item label="封面图样式" prop="floorType">
              <el-radio-group
                v-model="formData.floorType"
                style="width: 100%; margin-top: 10px"
              >
                <el-radio :label="1" id="logo" value="1">一张小图</el-radio>
                <el-radio :label="2" id="haitun" value="2">三张小图</el-radio>
                <el-radio :label="3" id="orange" value="3">一张大图</el-radio>
              </el-radio-group>
              <div
                style="width: 100%; position: relative; left: -10px; top: 5px"
              >
                <img
                  src="https://news-icon.oss-cn-beijing.aliyuncs.com/news_type_1.png"
                  style="width: 100px; height: 100px"
                />
                <img
                  src="https://news-icon.oss-cn-beijing.aliyuncs.com/news_type_3.png"
                  style="width: 100px; height: 100px; margin-left: 10px"
                />
                <img
                  src="https://news-icon.oss-cn-beijing.aliyuncs.com/news_type_2.png"
                  style="width: 100px; height: 100px; margin-left: 10px"
                />
              </div>
            </el-form-item>
          </el-row> -->

          <el-row>
            <div id="container" style="height: 350px">1111</div>
            <input
              id="tipinput"
              class="form-control input-style"
              placeholder="请输入关键字"
              value=""
            />
            <div class="input-card">
              <h4>经纬度：</h4>
              <div class="input-item">
                <input
                  type="text"
                  readonly="true"
                  class="form-control input-style"
                  id="lnglat"
                />
              </div>
            </div>
          </el-row>

          <!-- <el-row>
            <el-form-item label="轮播" prop="isRotation">
              <el-radio-group v-model="formData.isRotation" style="width:100%;margin-top:10px">
                <el-radio :label="1" value="1">轮播</el-radio>
                <el-radio :label="2" value="2">置顶</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-row> -->

          <el-row>
            <el-button
              type="primary"
              @click="handelSubmit('ruleForm')"
              style="marginleft: 85%"
              v-if="menuPerm('newfloor:insert')"
              >保存</el-button
            >
          </el-row>
        </el-form>
        <!-- style="position:absolute;right:10px;bottom:20px" -->
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        name: "", //楼盘名字
        quxian: "", //区县
        bieming: "", //别名
        shangquan: "", //商圈
        huanxianId: "", //环线 id，对应字典表【下拉框】
        address: "", //楼盘地址
        phone: "", //售楼处电话
        zhuzhaileiId: "", //住宅类别【下拉框】
        jianzhulouId: "", //建筑类别（楼样式），对应字典表【下拉框】
        // jianzhulouOther: "", //建筑类别（其他）“其他”说明
        bieshuTypeId: "", //别墅建筑类别(字典表）【下拉框】
        // bieshuTypeOther: "", //别墅建筑类别“其他”说明
        bieshuFenggeId: "", //别墅风格【下拉框】
        miaoshu: "", //物业描述
        jianjie: "", //项目简介
        chanquanId: "", //产权年限
        chanquanMiaoshu: "", //产权描述
        zhandiMianji: "", //占地面积，平方米
        jianzhuMianji: "", //建筑面积，苹方米
        rongji: "", //容积率
        lvhua: "", //绿化率
        loudong: "", //楼栋数
        zonghu: "", //总户数
        kaifa: "", //已开发期数
        dangqian: "", //当前期数
        zhuangkuang: "", //楼层状况
        chewei: "", //车位数量+车位描述
        cheweiChushou: "", //车位出售价格
        cheweiChuzu: "", //车位出租价格
        wuyefei: "", //物业费 单位：元/月
        zhuangxiuId: "", //装修状况（字段表）【下拉框】
        longitude: "", //坐标-经度
        latitude: "", //坐标-纬度
        gongdian: "", //供电
        jiegou: "", //结构
        gongqi: "", //供气
        waiqiang: "", //外墙
        cainuan: "", //采暖
        neiqiang: "", //内墙
        dianti: "", //电梯
        tongxun: "", //通讯
        hushu: "", //电梯服务户数
        menchuang: "", //门窗
        weishengjian: "", //卫生间
        datang: "", //大堂
        chufang: "", //厨房
        qiangmian: "", //首层大堂墙面
        dimian: "", //卧室地面
        cailiao: "", //地面材料
        diantijian: "", //电梯间
        tuliao: "", //室内涂料
        zoulang: "", //公共走廊，消防楼
        menjin: "", //门禁
        tiQiangmian: "", //电梯间墙面
        xinbaoxiang: "", //信报箱
        dianshi: "", //电视系统
        zhongshui: "", //中水系统
        kongtiao: "", //空调系统
        anfang: "", //安防系统
        weilan: "", //电子围栏
        jiaotong: "", //交通
        zhoubian: "", //周边设施
        neibu: "", //小区内部配套
        xiaoshouId: "", //销售状态（字典表）【下拉框】
        jieduanId: "", //销售阶段（字段表）【下拉框】

        jungong: "", //竣工时间
        kaipan: "", //开盘时间
        ruzhu: "", //入住时间
        shoulou: "", //售楼地址
        linshi: "", //临时售楼地址
        dianshi: "", //电视系统
        zhongshui: "", //中水系统
        kongtiao: "", //空调系统
        anfang: "", //安防系统
        weilan: "", //电子围栏
        jiaotong: "", //交通
        zhoubian: "", //周边设施
        neibu: "", //小区内部配套
        xiaoshouId: "", //销售状态（字典表）【下拉框】
        jieduanId: "", //销售阶段（字段表）【下拉框】

        jungong: "", //竣工时间
        kaipan: "", //开盘时间
        ruzhu: "", //入住时间
        shoulou: "", //售楼地址
        linshi: "", //临时售楼地址
        // xukezheng: "", //销售许可证
        bankId: "", //按揭银行 id（字典表
        junjia: "", //均价
        zuidi: "", //最低价
        cankao: "", //参考均价
        jiagemiao: "", //价格描述
        baojiaDate: "", //报价日期
        zhekou: "", //当前折扣
        // dongtai: "", //最新项目动态信息
        kaifashang: "", //开发商
        touzishang: "", //投资商
        wuyegongsi: "", //物业公司
        guwengongsi: "", //物业顾问公司
        yuanlindanwei: "", //建筑及园林设计单位
        chengjianshang: "", //承建商
        dailishang: "", //代理商
        jingguansheiji: "", //景观设计单位
        tuiguang: "", //整合推广单位
        pingmianmeiti: "", //平面媒体广告单位
        biaoqian: "", //标签
        floorType: "", //封面图片类型 1一张小图 2三张小图 3一张大图
        isRotation: "", //1 轮播，2 置顶,
        // jianzhucengOther: "", //建筑类别（层样式）
        isLike: "", //是否推荐猜你喜欢 0不推荐 1推荐
        jianzhucengId: "", //建筑类别（层样式）（字典表）
        score: "", //评分
      },
      quData: "", //区县---下拉
      huanData: "", //环形--下拉
      zhuData: "", //住宅--下拉
      jieData: "", //按揭银行 id（字典表）【下拉框】
      xiaoData: "", //销售阶段（字段表）【下拉框】
      xiaotai: "", //销售状态（字典表）【下拉框】

      xiuData: "", //装修状况（字段表）【下拉框】
      shuData: "", ////别墅风格（字典表）【下拉框】
      bieData: "", //别墅建筑类别(字典表）【下拉框】

      leiData: "", //建筑类别（层样式）（字典表）【下拉框】
      jianData: "", //建筑类别
      chanData: "", //产权===下拉
      aaa: "",
      isHot: "", //是否热门
    };
  },

  methods: {
    onChange(val) {
      this.formData.score = val;
    },
    //新增保存：
    handelSubmit(formName) {
      var baojiaDate, //报价日期
        ruzhu, //入住时间
        kaipan, //开盘时间
        jungong, //竣工时间
        kaigong; //开工时间

      //报价日期
      if (
        this.formData.baojiaDate == "" ||
        this.formData.baojiaDate == undefined
      ) {
        baojiaDate = this.formData.baojiaDate;
      } else {
        baojiaDate = this.formatDateTime(this.formData.baojiaDate);
      }
      //入住时间
      if (this.formData.ruzhu == "" || this.formData.ruzhu == undefined) {
        ruzhu = this.formData.ruzhu;
      } else {
        ruzhu = this.formatDateTime(this.formData.ruzhu);
      }
      //开盘时间
      if (this.formData.kaipan == "" || this.formData.kaipan == undefined) {
        kaipan = this.formData.kaipan;
      } else {
        kaipan = this.formatDateTime(this.formData.kaipan);
      }
      //竣工时间
      if (this.formData.jungong == "" || this.formData.jungong == undefined) {
        jungong = this.formData.jungong;
      } else {
        jungong = this.formatDateTime(this.formData.jungong);
      }
      //开工时间
      if (this.formData.kaigong == "" || this.formData.kaigong == undefined) {
        kaigong = this.formData.kaigong;
      } else {
        kaigong = this.formatDateTime(this.formData.kaigong);
      }
      if (document.getElementById("lnglat").value == "") {
        this.formData.longitude = 0;
        this.formData.latitude = 0;
      } else {
        this.formData.longitude = document
          .getElementById("lnglat")
          .value.split(",")[0];
        this.formData.latitude = document
          .getElementById("lnglat")
          .value.split(",")[1];
      }
      console.log(this.formData,'--88999')
      this.$refs[formName].validate(valid => {
      if (valid) {
      this.postAxios("/newfloor/insert", {
        name: this.formData.name, //楼盘名字
        quxian: Number(this.formData.quxian), //区县【下拉】
        bieming: this.formData.bieming, //别名
        shangquan: this.formData.shangquan, //商圈
        huanxianId: Number(this.formData.huanxianId), //环线 id，对应字典表【下拉框】
        address: this.formData.address, //楼盘地址
        phone: this.formData.phone, //售楼处电话
        zhuzhaileiId: Number(this.formData.zhuzhaileiId), //住宅类别【下拉框】
        jianzhulouId: Number(this.formData.jianzhulouId), //建筑类别（楼样式），对应字典表【下拉框】
        // jianzhulouOther: this.formData.jianzhulouOther, //建筑类别（其他）“其他”说明
        bieshuTypeId: Number(this.formData.bieshuTypeId), //别墅建筑类别(字典表）【下拉框】
        // bieshuTypeOther: this.formData.bieshuTypeOther, //别墅建筑类别“其他”说明
        bieshuFenggeId: Number(this.formData.bieshuFenggeId), //别墅风格（字典表）【下拉框】
        miaoshu: this.formData.miaoshu, //物业描述
        jianjie: this.formData.jianjie, //项目简介
        chanquanId: Number(this.formData.chanquanId), //产权年限（字典表）
        chanquanMiaoshu: this.formData.chanquanMiaoshu, //产权描述
        zhandiMianji: this.formData.zhandiMianji, //占地面积，平方米
        jianzhuMianji: this.formData.jianzhuMianji, //建筑面积，苹方米
        rongji: this.formData.rongji, //容积率
        lvhua: this.formData.lvhua, //绿化率
        loudong: Number(this.formData.loudong), //楼栋数
        zonghu: Number(this.formData.zonghu), //总户数
        kaifa: this.formData.kaifa, //已开发期数
        dangqian: this.formData.dangqian, //当前期数
        zhuangkuang: this.formData.zhuangkuang, //楼层状况
        chewei: this.formData.chewei, //车位数量+车位描述
        cheweiChushou: this.formData.cheweiChushou, //车位出售价格
        cheweiChuzu: this.formData.cheweiChuzu, //车位出租价格
        wuyefei: this.formData.wuyefei, //物业费 单位：元/月
        zhuangxiuId: Number(this.formData.zhuangxiuId), //装修状况（字段表）【下拉框】
        longitude: this.formData.longitude, //坐标-经度
        latitude: this.formData.latitude, //坐标-纬度
        gongdian: this.formData.gongdian, //供电
        jiegou: this.formData.jiegou, //结构
        gongqi: this.formData.gongqi, //供气
        waiqiang: this.formData.waiqiang, //外墙
        cainuan: this.formData.cainuan, //采暖
        neiqiang: this.formData.neiqiang, //内墙
        dianti: this.formData.dianti, //电梯
        tongxun: this.formData.tongxun, //通讯
        hushu: this.formData.hushu, //电梯服务户数
        menchuang: this.formData.menchuang, //门窗
        weishengjian: this.formData.weishengjian, //卫生间
        datang: this.formData.datang, //大堂
        chufang: this.formData.chufang, //厨房
        qiangmian: this.formData.qiangmian, //首层大堂墙面
        dimian: this.formData.dimian, //卧室地面
        cailiao: this.formData.cailiao, //地面材料
        diantijian: this.formData.diantijian, //电梯间
        tuliao: this.formData.tuliao, //室内涂料
        zoulang: this.formData.zoulang, //公共走廊，消防楼
        menjin: this.formData.menjin, //门禁
        tiQiangmian: this.formData.tiQiangmian, //电梯间墙面
        xinbaoxiang: this.formData.xinbaoxiang, //信报箱
        dianshi: this.formData.dianshi, //电视系统
        zhongshui: this.formData.zhongshui, //中水系统
        kongtiao: this.formData.kongtiao, //空调系统
        anfang: this.formData.anfang, //安防系统
        weilan: this.formData.weilan, //电子围栏
        jiaotong: this.formData.jiaotong, //交通
        zhoubian: this.formData.zhoubian, //周边设施
        neibu: this.formData.neibu, //小区内部配套
        xiaoshouId: Number(this.formData.xiaoshouId), //销售状态（字典表）【下拉框】
        jieduanId: Number(this.formData.jieduanId), //销售阶段（字段表）【下拉框】
        // kaigong: this.formatDateTime(this.formData.kaigong), //开工时间
        kaigong: kaigong, //开工时间
        // jungong: this.formatDateTime(this.formData.jungong), //竣工时间
        jungong: jungong, //竣工时间
        // kaipan: this.formatDateTime(this.formData.kaipan), //开盘时间
        kaipan: kaipan, //开盘时间
        // ruzhu: this.formatDateTime(this.formData.ruzhu), //入住时间
        ruzhu: ruzhu, //入住时间
        shoulou: this.formData.shoulou, //售楼地址
        linshi: this.formData.linshi, //临时售楼地址
        // xukezheng: this.formData.xukezheng, //销售许可证
        bankId: Number(this.formData.bankId), //按揭银行 id（字典表
        junjia: this.formData.junjia, //均价
        zuidi: this.formData.zuidi, //最低价
        cankao: this.formData.cankao, //参考均价
        jiagemiao: this.formData.jiagemiao, //价格描述
        // baojiaDate: this.formatDateTime(this.formData.baojiaDate), //报价日期
        baojiaDate: baojiaDate, //报价日期
        zhekou: this.formData.zhekou, //当前折扣
        // dongtai: this.formData.dongtai, //最新项目动态信息
        kaifashang: this.formData.kaifashang, //开发商
        touzishang: this.formData.touzishang, //投资商
        wuyegongsi: this.formData.wuyegongsi, //物业公司
        guwengongsi: this.formData.guwengongsi, //物业顾问公司
        yuanlindanwei: this.formData.yuanlindanwei, //建筑及园林设计单位
        chengjianshang: this.formData.chengjianshang, //承建商
        dailishang: this.formData.dailishang, //代理商
        jingguansheiji: this.formData.jingguansheiji, //景观设计单位
        tuiguang: this.formData.tuiguang, //整合推广单位
        pingmianmeiti: this.formData.pingmianmeiti, //平面媒体广告单位
        biaoqian: this.formData.biaoqian, //标签
        floorType: Number(this.formData.floorType), //封面图片类型 1一张小图 2三张小图 3一张大图
        isRotation: this.formData.isRotation, //1 轮播，2 置顶
        // jianzhucengOther: this.formData.jianzhucengOther, //建筑类别（层样式）
        zuigao: this.formData.zuigao, //最高
        isLike: this.formData.isLike, //是否推荐猜你喜欢 0不推荐 1推荐
        isHot: this.formData.isHot, //是否推荐猜你喜欢 0不推荐 1推荐
        jianzhucengId: this.formData.jianzhucengId, //建筑类别（层样式）（字典表）
        score: this.formData.score,
      }).then((res) => {
        if (res.success == true) {
          // this.phoneInit();
          this.$router.push({
            path: "/house",
          });
          this.$message.success("新增成功");
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
      }
      else {
        this.$message.error("内容不能为空");
        return false;
      }
      });
    },
    //环线：huanxian
    handleHuan() {
      this.getAxios(`/dic/list/huanxian`, {}).then((res) => {
        if (res.success == true) {
          this.huanData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //住宅
    handleZhu() {
      this.getAxios(`/dic/list/zhuzhai`, {}).then((res) => {
        if (res.success == true) {
          this.zhuData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //建筑类别
    handleJian() {
      this.getAxios(`/dic/list/zhuzhailouxing`, {}).then((res) => {
        if (res.success == true) {
          this.jianData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //建筑类别（层样式）（字典表）【下拉框】
    hanldeZhu() {
      this.getAxios(`/dic/list/cengxing`, {}).then((res) => {
        if (res.success == true) {
          this.leiData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //别墅建筑类别(字典表）【下拉框】
    handleBie() {
      this.getAxios(`/dic/list/bieshuliebie`, {}).then((res) => {
        if (res.success == true) {
          this.bieData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //别墅风格（字典表）【下拉框】
    handleShu() {
      this.getAxios(`/dic/list/bieshufengge`, {}).then((res) => {
        if (res.success == true) {
          this.shuData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //装修状况（字段表）【下拉框】
    handleXiu() {
      this.getAxios(`/dic/list/zhuangxiuzhuangkuang`, {}).then((res) => {
        if (res.success == true) {
          this.xiuData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //销售状态（字典表）【下拉框】
    handleXiao() {
      this.getAxios(`/dic/list/xiaoshoustatus`, {}).then((res) => {
        if (res.success == true) {
          this.xiaotai = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //销售阶段（字段表）【下拉框】
    handleShou() {
      this.getAxios(`/dic/list/xiaoshoujieduan`, {}).then((res) => {
        if (res.success == true) {
          this.xiaoData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //按揭银行 id（字典表）【下拉框】
    handleJie() {
      this.getAxios(`/dic/list/anjiebank`, {}).then((res) => {
        if (res.success == true) {
          this.jieData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //产权年限【下拉框】
    handlechanData() {
      this.getAxios(`/dic/list/chanquan`, {}).then((res) => {
        if (res.success == true) {
          this.chanData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //区县：
    selectQu() {
      this.getAxios(`/dic/list/tianjinquxian`, {}).then((res) => {
        if (res.success == true) {
          this.quData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },

    addZero(num) {
      return num < 10 ? "0" + num : num;
    },
    formatDateTime(date) {
      const time = new Date(Date.parse(date));
      // time.setTime(time.setHours(time.getHours() + 8));
      const Y = time.getFullYear() + "-";
      const M = this.addZero(time.getMonth() + 1) + "-";
      const D = this.addZero(time.getDate()) + " ";
      const h = this.addZero(time.getHours()) + ":";
      const m = this.addZero(time.getMinutes()) + ":";
      const s = this.addZero(time.getSeconds());
      // const s = this.addZero(time.getSeconds());
      return Y + M + D + h + m + s;
    },
    searchInit() {
      var map = new AMap.Map("container", {
        resizeEnable: true,
        isHotspot: true,
      });
      AMap.plugin(["AMap.Autocomplete", "AMap.PlaceSearch"], function () {
        var autoOptions = {
          city: "天津",
          input: "tipinput", //使用联想输入的input的id（也就是上边那个唯一的id）
        };
        var autocomplete = new AMap.Autocomplete(autoOptions);
        var placeSearch = new AMap.PlaceSearch({
          map: map,
        });
        AMap.event.addListener(autocomplete, "select", function (e) {
          //TODO 针对选中的poi实现自己的功能
          placeSearch.setCity(e.poi.adcode);
          placeSearch.search(e.poi.name);
          document.getElementById("lnglat").value =
            e.poi.location.lng + "," + e.poi.location.lat;
        });
      });
    },
  },
  created() {
    this.handleHuan(); //环线
    this.handleZhu(); //住宅
    this.handleJian(); ////建筑类别
    this.hanldeZhu(); ////建筑类别（层样式）（字典表）【下拉框】
    this.handleBie(); // //别墅建筑类别(字典表）【下拉框】
    this.handleShu(); // //别墅风格（字典表）【下拉框】
    this.handleXiu(); //装修状况（字段表）【下拉框】
    this.handleXiao(); //销售状态（字典表）【下拉框】
    this.handleShou(); //销售阶段（字段表）【下拉框】
    this.handleJie(); //按揭银行 id（字典表）【下拉框】
    this.handlechanData(); //产权年限【下拉框】
    this.selectQu(); //区县【下拉框】
  },
  mounted() {
    this.searchInit();
  },
};
</script>
<style scoped lang="less">
.houseAdd {
  width: 100%;
  height: 100%;
  .box-card {
    width: 95%;
    height: auto;
    margin: 0 auto;
    margin-top: 30px;
    /deep/ .el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      width: 100px;
      margin-top: 10px;
      margin-left: 10px;
    }
    /deep/ .el-textarea__inner {
      display: block;
      resize: vertical;
      padding: 5px 15px;
      line-height: 1.5;
      box-sizing: border-box;
      font-size: inherit;
      color: #606266;
      background-color: #fff;
      background-image: none;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 1043px;
      // height: 100px;
    }
  }
}
#myPageTop {
  position: absolute;
  top: 0;
}
#tipinput {
  position: absolute;
  top: 0;
}
.input-card {
  position: absolute;
  right: 20px;
  bottom: 20px;
  background: #fff;
}
/deep/.setIpt input {
  width: 620px !important;
}
/deep/.setIpt textarea {
  width: 960px !important;
}
/deep/.ipt input {
  width: 1044px !important;
}
.flexForm {
  display: flex;
}
/deep/ .flexForm .el-form-item__content {
  display: flex;
}
</style>
